import { createContext } from 'react'
import { AccordionFaqContextState } from '@/types'

const contextDefaultValues = {
  expanded: true,
  toggleExpanded: () => {},
}

export const AccordionFaqContext =
  createContext<AccordionFaqContextState>(contextDefaultValues)
